import { action } from 'easy-peasy';
import { IActionDeleteNotifications } from '../types';

const deleteNotifications: IActionDeleteNotifications = action((state, ids) => {
  state.items = state.items.filter(item => !ids.includes(item.id));
});

export default deleteNotifications;
